import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiDialog from "components/Custom/UiDialog";

import { COMMON_JS } from "common/scripts";
import { DEFAULTS, FORMATS, NOTIFY } from "common/config";
import { DateFunctions } from "common/datefunctions";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/lables";

import { MASTER_APIs } from "apihandlers/master";
import { USER_APIs } from "apihandlers/user";
import Area from "components/Masters/Area";
import { GEO_APIs } from "apihandlers/geography";
import { CUSTOMER_APIs } from "apihandlers/customer";
import RichTxtBox from "components/Custom/RichTxtBox";

const Feedback = (props: any) => {
  const { setDashMenu } = props;

  const [rows, setRows] = useState<any>([{}]);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [gridLoading, setGridLoading] = useState(true);

  const [isSubmit, setIsSubmit] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [mandatoryLoadResults, setMandatoryLoadResults] = useState<any[]>([]);

  const [users, setUsers] = useState([]);
  const [area, setArea] = useState([]);
  const [messageRow, setMessageRow] = useState<any>(
    selectedRow.messages ? selectedRow.messages : []
  );

  const usersRef: any = useRef(null);
  const areaRef: any = useRef(null);
  const messageGridRef: any = useRef(null);
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "subjectName",
      name: LABELS.SUBJECT_NAME,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "personName",
      name: LABELS.NAME,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "mobileNo",
      name: LABELS.MOBILE_NUMBER,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "areaName",
      name: LABELS.AREA,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "feedbackDate",
      name: LABELS.FEEDBACK_DATE,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "feedBack",
      name: LABELS.FEEDBACK_COMPLAINT,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },

    {
      key: "activeStatus",
      name: LABELS.ACTIVE,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      searchable: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  // const messageColumns = [
  //   {
  //     key: "type",
  //     name: LABELS.TYPE,
  //     width: "50%",
  //     type: "dropdown",
  //     align: "center",
  //     headerAlign: "center",
  //     editable: true,
  //     sortable: false,
  //     searchable: false,
  //     list: [
  //       {
  //         id: "Feedback",
  //         label: "FEEDBACK",
  //       },
  //       {
  //         id: "Complaints",
  //         label: "COMPLAINTS",
  //       },
  //     ],
  //   },
  //   {
  //     key: "comments",
  //     name: LABELS.COMMENTS,
  //     width: "50%",
  //     type: "text",
  //     align: "center",
  //     headerAlign: "center",
  //     editable: true,
  //     sortable: false,
  //     searchable: false,
  //   },
  // ];

  useEffect(() => {
    if (loading) {
      getUsers();
    }
  }, [loading]);

  const getUsers = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    USER_APIs.getUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setUsers(list);
        getAsset();
        // getRows();
      }
    });
  };

  const getAsset = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setArea(list);
        // getRows();
      }
    });
  };
  // const getRows = () => {
  //   const args = {
  //     pageNo: 1,
  //     pageLength: DEFAULTS.PAGE_LENGTH,
  //   };
  //   MASTER_APIs.getVehicleChecks(args).then((res: any) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       let list = response.records;
  //       for (let i = 0; i < list.length; i++) {
  //         list[i]["slNo"] = i + 1;
  //         if (list[i]["activeStatus"]) {
  //           list[i]["activeStatus"] = "Yes";
  //         } else {
  //           list[i]["activeStatus"] = "No";
  //         }
  //       }
  //       setRows(list);
  //       setLoading(false);
  //     }
  //   });
  // };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
    setMessageRow([]);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    setMessageRow(JSON.parse(row.feedbackDetails));
  };

  const reloadGrid = () => {
    setRows(null);
    loadGrid();
  };

  const loadGrid = () => {
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;

    setLoading(true);
    let loadErrors = [];

    if (fromDt === "") {
      loadErrors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      loadErrors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setGridLoading(false);

    setMandatoryLoadResults(loadErrors);
    if (loadErrors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      fromDt,
      toDt,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    //TODO API IS STILL IN PROGRESS

    CUSTOMER_APIs.getFeedbacks(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    });
  };
  const manageRecord = () => {
    const subjectName = (
      document.getElementById("subjectName") as HTMLInputElement
    ).value.trim();
    const personName = (
      document.getElementById("personName") as HTMLInputElement
    ).value.trim();
    const feedbackDate = (
      document.getElementById("feedbackDate") as HTMLInputElement
    ).value.trim();
    const mobileNo = (
      document.getElementById("mobileNo") as HTMLInputElement
    ).value.trim();
    const areaId = areaRef.current.selectedValue.id;
    const remarks = (
      document.querySelector("#feedback .ql-editor") as HTMLElement
    ).innerHTML;

    // let ele = document.querySelector(
    //   'input[name="activeStatus"]:checked'
    // ) as HTMLInputElement;
    // const activeStatus = ele ? ele.value : "";
    //todo:Validations needs to be done

    // Validations;
    let errors = [];
    if (personName === "") {
      errors.push({
        id: "personName",
        msg:
          "<span class='bold'>" +
          LABELS.PERSON_NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!areaId) {
      errors.push({
        id: "area",
        msg:
          "<span class='bold'>" +
          LABELS.AREA +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      subjectName,
      personName,
      feedbackDate,
      mobileNo,
      areaId,
      remarks,
      // feedbackDetails: messageGridRef.getRowData(),
      // activeStatus,
    };
    setSelectedRow({});
    setManageDialog(false);
    reloadGrid();

    console.log("args", args);
    setIsSubmit(true);
    //TODO API IS STILL IN PROGRESS

    // CUSTOMER_APIs.manageFeedback(args).then((res) => {
    //   setIsSubmit(false);
    //   if (res.status === 200) {
    //     COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
    //     setSelectedRow({});
    //     setManageDialog(false);
    //     reloadGrid();
    //   } else {
    //     COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
    //   }
    // });
  };

  const getDeaultItemRow = () => {
    const newRow: any = {
      id: "1." + (messageGridRef.getRowData().length + 1).toString(),
    };
    return newRow;
  };

  console.log("Page: Country:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.CRM_TRANSACTION}{" "}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.FEEDBACK}</li>
        </ul>
        <h4>{TITLES.FEEDBACK}</h4>
        <p>{SUB_TITLES.FEEDBACK}</p>
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <div
          className="formGroup"
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 0,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.FROM_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="fromDt"
              defaultValue={DateFunctions.getDate(
                "today",
                "from",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.TO_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="toDt"
              defaultValue={DateFunctions.getDate(
                "thismonth",
                "to",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              padding: 10,
              marginTop: "0.3rem",
            }}
          >
            <Btn
              text={LABELS.LOAD}
              onClick={loadGrid}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
        </div>
      </div>
      {/* mandatoryResults */}
      {mandatoryLoadResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryLoadResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="grid excelGridWrapper">
        {!gridLoading &&
          (rows ? (
            <ExcelGrid
              id={"feedback"}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.FEEDBACK}
              onReload={reloadGrid}
              onAdd={onAdd}
            />
          ) : (
            <div className="flexRowCenter">
              <Loader />
            </div>
          ))}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.FEEDBACK + ": " + selectedRow.personName
              : "Add " + TITLES.FEEDBACK
          }
          open={true}
          size={"md"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
            setMandatoryLoadResults([]);
          }}
        >
          <div className="flexColumn">
            <div className="formGroup  ">
              <TxtRow
                id={"subjectName"}
                label={LABELS.SUBJECT_NAME}
                defaultValue={selectedRow.id ? selectedRow.subjectName : ""}
                type={"text"}
                required={true}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup  ">
              <TxtRow
                id={"personName"}
                label={LABELS.PERSON_NAME}
                defaultValue={selectedRow.id ? selectedRow.personName : ""}
                type={"text"}
                required={true}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup  ">
              <TxtRow
                id={"mobileNo"}
                label={LABELS.MOBILE_NUMBER}
                defaultValue={selectedRow.id ? selectedRow.mobileNo : ""}
                type={"text"}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup required ">
              <label>{LABELS.AREA}</label>
              {<span>*</span>}
              <AutoComplete
                list={area}
                childRef={areaRef}
                defaultValue={
                  selectedRow.areaId
                    ? {
                        id: selectedRow.areaId,
                        label: selectedRow.areaName,
                      }
                    : null
                }
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup  ">
              <TxtRow
                id={"feedbackDate"}
                label={LABELS.FEEDBACK_DATE}
                type={"date"}
                defaultValue={
                  selectedRow.feedbackDate
                    ? DateFunctions.getFormatedDate(
                        selectedRow.feedbackDate,
                        FORMATS.DATE_ONLY,
                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",
                        "from",
                        FORMATS.SQL_DATE_ONLY
                      )
                }
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup  ">
              <label>{LABELS.FEEDBACK_COMPLAINT}</label>
              <RichTxtBox id={"feedback"} />
            </div>

            {/* <div className="formGroup  ">
              <label>{LABELS.USER}</label>
              
              <AutoComplete
                list={users}
                childRef={usersRef}
                // defaultValue={
                //   selectedRow.userId
                //     ? {
                //         id: selectedRow.userId,
                //         label: selectedRow.name,
                //       }
                //     : null
                // }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div> */}

            {/* <div className="formGroup required">
              <label>
                {LABELS.ACTIVE_STATUS}
                <span>*</span>
              </label>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Yes"
                      : true,
                    disabled: isSubmit,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "No"
                      : false,
                    disabled: isSubmit,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                required={true}
                disabled={isSubmit}
              />
            </div> */}

            {/* <div
              className="grid"
              style={{
                width: "100%",
                height: "80%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ExcelGrid
                id={"message"}
                height={600}
                childRef={messageGridRef}
                cols={messageColumns}
                rows={messageRow}
                exportOption={false}
                newRowOption={false}
                getDefaultNewRow={getDeaultItemRow}
              />
            </div> */}
            {/* mandatoryResults */}
            {mandatoryResults.length > 0 && (
              <div className="mandatoryBox">
                <ul>
                  {mandatoryResults.map((m) => {
                    return (
                      <li>
                        <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            <div className="formGroup submitBtnWrapper">
              <div className="flexbtnjustify">
                <Btn
                  text={LABELS.CANCEL}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={() => {
                    setManageDialog(false);
                    setMandatoryResults([]);
                    setMandatoryLoadResults([]);
                  }}
                  loading={isSubmit}
                />
                <Btn
                  text={LABELS.SAVE}
                  onClick={manageRecord}
                  loading={isSubmit}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};
export default withSnackbar(Feedback);
